import { render, staticRenderFns } from "./assetsInfo.vue?vue&type=template&id=a4aeaa28&scoped=true&"
import script from "./assetsInfo.vue?vue&type=script&lang=js&"
export * from "./assetsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4aeaa28",
  null
  
)

export default component.exports